import { inject, Injectable } from '@angular/core';
import { MarketplaceBasketCustomFieldModel } from '../../marketplace/models/basket/marketplace-basket-customfield.model';
import { CartV2Store } from './cart-v2.store';
import { ErrorStateService } from '../../../shared/services/core/error.service';
import { TranslateService } from '@ngx-translate/core';
import { MarketplaceItemAttributeValue } from '../../marketplace/models/attributes/marketplace-item-attribute-value.model';
@Injectable({
  providedIn: 'root',
})
export class CartV2Service {
  private cartStore = inject(CartV2Store);
  private errorStateService = inject(ErrorStateService);
  private translate = inject(TranslateService);

  addItemToCart(
    item: any,
    quantity: number,
    attribute?: MarketplaceItemAttributeValue,
    customFields?: MarketplaceBasketCustomFieldModel[]
  ): void {
    const cartItem = this.cartStore.getCartItem(item.Id, attribute?.AttributeMappingId, customFields);

    let cartQty = 0;
    let isUnlimited = !item?.StockCount;
    let stock = item.StockCount || 0;

    if (this.isAttributeItem(item)) {
      stock = attribute?.AvailableStockCount || 0;
      isUnlimited = attribute?.UnlimitedStock ?? false;
    }

    if (cartItem()) {
      cartQty = cartItem()?.purchaseQuantity || 0;
    }
    const available = stock - cartQty;

    if (quantity > available && !isUnlimited) {
      const errorMessage = this.translate.instant('marketplace.error.item.cart.quantity.exceeded', { max: available });
      this.errorStateService.addError(errorMessage);
      return;
    }

    this.cartStore.upsertCartItem(item, quantity, attribute, customFields);
  }

  removeAll(): void {
    this.cartStore.removeAll();
  }

  remove(id: string): void {
    this.cartStore.remove(id);
  }

  refreshItems(): void {
    this.cartStore.refreshItems();
  }

  private isAttributeItem(item: any): boolean {
    return item.Attributes && item.Attributes.length > 0;
  }
}
